import type { ApprovalTimerInput } from './approval.types';

export function secondsUntil(expiresAt?: string | null, nowMs = Date.now()): number {
  const expiresMs = new Date(expiresAt || '').getTime();
  if (!Number.isFinite(expiresMs)) return 0;
  return Math.max(0, Math.floor((expiresMs - nowMs) / 1000));
}

export function isTimerExpired(expiresAt?: string | null, nowMs = Date.now()): boolean {
  return secondsUntil(expiresAt, nowMs) <= 0;
}

export function formatCountdown(seconds: number): string {
  const safeSeconds = Math.max(0, Number(seconds) || 0);
  const minutes = Math.floor(safeSeconds / 60);
  const rest = safeSeconds % 60;
  return minutes > 0 ? `${minutes}m ${String(rest).padStart(2, '0')}s` : `${rest}s`;
}

export function shouldHideQrByTimer(input: ApprovalTimerInput, nowMs = Date.now()): boolean {
  if (input.status && input.status !== 'PENDENTE') return true;
  if (Number(input.approvalSecondsRemaining) <= 0) return true;
  if (input.handoffExpiresAt && isTimerExpired(input.handoffExpiresAt, nowMs)) return true;
  return false;
}
